// extracted by mini-css-extract-plugin
export default {"about":"about_about__IOyX3","about__textarea":"about_about__textarea__bRXg3"};